import { gql } from "@apollo/client";
export const FindCompanyTotalBalances = gql `
  query Query($input: FindCompanyTotalBalancesInput!) {
    FindCompanyTotalBalances(input: $input)
  }
`;
